import { Box, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import "react-image-gallery/styles/css/image-gallery.css";

import TCOMain from "../../modules/TCO/tcoMain";
import TurnoAssured from "../../modules/TCO/turnoAssured";
import TurnoBenefits from "../../modules/TCO/turnoBenefits";
import { sendAnalytics } from "../../utils/analyticsCommon";

const CustomTCOPage = styled(Box)(() => ({}));

const TCOPage = () => {
  useEffect(() => {
    sendAnalytics("screen_viewed", { screen_name: "TCO" }, "en");
  }, []);

  const [x, setX] = useState("fixed");
  return (
    <CustomTCOPage>
      <TCOMain x={x} setX={setX} />
      <TurnoBenefits />
      <TurnoAssured x={x} setX={setX} />
    </CustomTCOPage>
  );
};

export default TCOPage;
